module.exports = __webpack_public_path__ + "media/images/workflow-user-7578327f65e23f86969e97ddf43bcdf5.jpg";